/**
 * Recursively freeze plain objects (Form.io option trees are nested plain objects).
 * @param {object} o
 */
const deepFreeze = (o) => {
  if (o === null || typeof o !== 'object') {
    return o;
  }
  Object.freeze(o);
  Object.keys(o).forEach((k) => {
    const v = o[k];
    if (v && typeof v === 'object' && !Object.isFrozen(v)) {
      deepFreeze(v);
    }
  });
  return o;
};

/** Default Form.io form definition stored in the portal `schema` field. */
export const EMPTY_FORMIO_FORM = deepFreeze({
  display: 'form',
  components: [],
});

/**
 * Form.io FormBuilder options: hide palette groups/components.
 * Do not set `builder.advanced.components.datetime` to a partial `{ schema }` only: WebformBuilder
 * treats that as the full sidebar entry and blocks the real DateTime, which renders as an empty tile.
 * Reference: `@formio/js` WebformBuilder merges `options.builder` with defaults via `defaultsDeep`.
 */
export const FORM_BUILDER_OPTIONS = deepFreeze({
  builder: {
    premium: false,
    data: false,
    basic: {
      components: {
        button: { ignore: true },
      },
    },
    advanced: {
      components: {
        address: { ignore: true },
      },
    },
    layout: {
      components: {
        htmlelement: { ignore: true },
      },
    },
  },
});
